import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactDatatable from "@ashvin27/react-datatable";
import ApiConnect from "../../../../Utils/ApiConnect";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import AutoComplete from "../../../Components/AutoComplete";
import DeletePop from "../../../Components/DeletePop";
export default function UserManagement() {
  const usersList = useSelector((state) => state.Utilities.Users);
  const dispatch = useDispatch();
  const [Viewmodal, Setviewmodal] = useState(false);
  const [ModalName, SetModalName] = useState("");
  const [formError, SetformError] = useState();
  const [UserRoles, setUserRoles] = useState([]);
  const [EmployeeList, setEmployeeList] = useState([]);
  const [UserData, setUserData] = useState([]);
  const [btnDisable, setBtnDisable] = useState(false);
  const [usernameError, setusernameError] = useState("");
  const [deleteModal, SetdeleteModal] = useState(false);
  const [selectedId, SetselectedId] = useState(false);
  useEffect(() => {
    fetchusersData();
    fetchEmployeeDetails();
  }, []);
  const columns = [
    {
      key: "name",
      text: "Name",
      sortable: true,
      cell: (record) => {
        return (
          <div className="media d-inline-flex">
            <img
              className="avatar avatar-lg"
              src={record.image}
              alt={record.name}
            />
            <div className="media-body">
              <p className="lh-1">
                {record.name}
                <small className="sidetitle">{record.role}</small>
              </p>
              <small>{record.username}</small>
            </div>
          </div>
        );
      },
    },
    {
      key: "contact",
      text: "Contact",
    },
    {
      key: "status",
      text: "Status",
      cell: (record) => {
        return (
          <span
            onClick={(e) => ChangeStatus(e, record.id)}
            className={`badge badge-pill badge-${
              record.status === "1" ? "success" : "danger"
            }`}
          >
            {record.status === "1" ? "Active" : "Deactivate"}
          </span>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "table-actions",
      width: 150,
      sortable: false,
      align: "center",
      cell: (record) => {
        return (
          <React.Fragment>
            <button
              className="table-action btn btn-square btn-pure hover-warning"
              onClick={() => {
                Setviewmodal(true);
                SetModalName("Edit");
              }}
            >
              <span className="material-icons-outlined">edit_note</span>
            </button>
            <button
              className="table-action btn btn-square btn-pure hover-danger"
              onClick={() => {
                SetdeleteModal(true);
                SetselectedId(record.id);
              }}
            >
              <span className="material-icons-outlined">delete</span>
            </button>
          </React.Fragment>
        );
      },
    },
  ];
  const config = {
    key_column: "id",
    page_size: 10,
    length_menu: [10, 20, 50],
    show_filter: true,
    show_pagination: true,
    button: {
      // excel: true,
      // print: true
    },
    language: {
      loading_text: "Please be patient while data loads...",
    },
  };

  const fetchusersData = (id) => {
    ApiConnect.get(`/Module/Utilities/Users/Details?id=${id ? id : ""}`)
      .then((response) => {
        let Users = response.data;
        dispatch({ type: "SET_UTILITIES_USERS", payload: { Users } });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchEmployeeDetails = () => {
    ApiConnect.get("/Module/Utilities/Users/EmployeeRoles")
      .then((response) => {
        setUserRoles(response.data.Role);
        setEmployeeList(response.data.Employee);
      })
      .catch((error) => console.log(error));
  };
  const ChangeStatus = (e, id) => {
    ApiConnect.put(`/Module/Utilities/Users/EditStatus?id=${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          if (e.target.classList.contains("badge-success")) {
            e.target.classList.replace("badge-success", "badge-danger");
            e.target.innerHTML = "Deactivate";
          } else {
            e.target.classList.replace("badge-danger", "badge-success");
            e.target.innerHTML = "Active";
          }
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          fetchusersData();
        } else {
          toast.warning(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  };

  const handleChange = (id, name, value) => {
    const newData = { ...UserData };
    newData[name] = value;
    setUserData(newData);
  };
  const handleAutoComplete = (data) => {
    const newData = { ...UserData };
    newData["employee"] = data.id;
    setUserData(newData);
  };
  const UsernameCheck = (e) => {
    ApiConnect.get(`/Module/Utilities/Users/UsernameCheck?username=${e}`).then(
      (response) => {
        if (response.data.status === 202) {
          setBtnDisable(true);
          setusernameError(response.data.message);
        } else {
          setBtnDisable(false);
          setusernameError(response.data.message);
        }
      }
    );
  };
  const CreateNewUser = (e) => {
    e.preventDefault();
    var Fdata = new FormData();
    Fdata.append("employee", UserData.employee);
    Fdata.append("username", UserData.username);
    Fdata.append("password", UserData.password);
    Fdata.append("role", UserData.role);
    ApiConnect({
      method: "post",
      url: "/Module/Utilities/Users/CreateNewUser",
      data: Fdata,
    })
      .then((response) => {
        if (response.data.status === 201) {
          fetchusersData();
          Setviewmodal(false);
          setUserData([]);
          toast.success(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        } else if (response.data.status === 406) {
          SetformError(response.data.message);
        } else {
          toast.error(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  };
  return (
    <div className="p-0 m-0">
      <header className="header no-border">
        <div className="header-info">
          <div className="left">
            <h2 className="header-title">
              <strong>User Management</strong>
              <small className="subtitle">
                Here you can edit,delete,view User & Roles.
              </small>
            </h2>
          </div>
          <div className=" gap-items-2 z-10">
            <button
              className="btn btn-primary  btn-float btn-round"
              onClick={() => {
                Setviewmodal(true);
                SetModalName("New");
              }}
            >
              <span className="material-icons-outlined">add</span>
            </button>
          </div>
        </div>
      </header>
      <div className="card">
        <div className="card-body">
          <div className="dataTables_wrapper">
            <ReactDatatable
              className="table table-separated"
              config={config}
              records={usersList}
              columns={columns}
            />
          </div>
        </div>
        <Modal
          show={Viewmodal}
          className="modal-center"
          onHide={() => Setviewmodal(false)}
        >
          <Modal.Dialog>
            <Modal.Header>
              <h5 className="modal-title">{ModalName} User</h5>
              <button
                type="button"
                className="btn"
                onClick={() => Setviewmodal(false)}
              >
                <span>×</span>
              </button>
            </Modal.Header>
            <form onSubmit={(e) => CreateNewUser(e)}>
              <Modal.Body>
                <p className="text-danger">{formError}</p>
                <div className="row form-group">
                  <div className="col">
                    <label className="form-label">Employee Name</label>
                    <AutoComplete
                      name="employee"
                      action={handleAutoComplete}
                      placeHolder="Employee Name"
                      styleName=""
                      items={EmployeeList}
                    />
                  </div>
                  <div className="col">
                    <label className="form-label">Role Name</label>
                    <label className="col-12">
                      <select
                        className="form-control"
                        name="role"
                        onChange={(e) =>
                          handleChange("", e.target.name, e.target.value)
                        }
                      >
                        <option>Select Role</option>
                        {UserRoles.map((role, index) => (
                          <option value={role.id} key={index}>
                            {role.name}
                          </option>
                        ))}
                      </select>
                    </label>
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col">
                    <label className="form-label">
                      Username <small>{usernameError}</small>
                    </label>
                    <label className="col-12">
                      <input
                        onChange={(e) =>
                          handleChange("", e.target.name, e.target.value)
                        }
                        onBlur={(e) => UsernameCheck(e.target.value)}
                        type="text"
                        className="form-control"
                        name="username"
                        required="required"
                      />
                    </label>
                  </div>
                  <div className="col">
                    <label className="form-label">Password</label>
                    <label className="col-12">
                      <input
                        onChange={(e) =>
                          handleChange("", e.target.name, e.target.value)
                        }
                        type="text"
                        className="form-control"
                        name="password"
                        required="required"
                      />
                    </label>
                  </div>
                </div>
                <div className="row form-group">
                  <label className="form-label">Email</label>
                  <div className="col custom-control custom-control-lg custom-checkbox">
                    <input type="checkbox" className="custom-control-input" />
                    <label className="custom-control-label" htmlFor="ccs-3">
                      Email
                    </label>
                  </div>
                  <div className="col custom-control custom-control-lg custom-checkbox">
                    <input type="checkbox" className="custom-control-input" />
                    <label className="custom-control-label" htmlFor="ccs-3">
                      SMS
                    </label>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={btnDisable}
                >
                  {ModalName === "New" ? "Create" : "Edit"}
                </button>
              </Modal.Footer>
            </form>
          </Modal.Dialog>
        </Modal>
      </div>
      <DeletePop
        trigger={deleteModal}
        delUrl={`/Module/Utilities/Users/DeleteCompanyPermission?id=${selectedId}`}
        hideTrigger={SetdeleteModal}
        fallAction={fetchusersData}
      />
    </div>
  );
}
